<ds-modal
  [modal]="modal"
  [slideOutLayout]="true"
  [title]="'user_settings_modal_title' | translate"
  [headerIcon]="Icons.Cog"
  [maxWidthPercentage]="80"
  titleHeadingStyle="h2"
  (modalClosed)="onCancel()"
  class="account-settings-modal"
>
  <div class="account-settings-modal-content">
    <div class="list-menu-container">
      <ds-list-menu [menuAriaLabel]="'user_settings_modal_title' | translate" [menuItems]="menuItems()"></ds-list-menu>
    </div>
    <div class="content">
      <section
        class="section"
        [class.section-hidden]="activeSection() !== 'profile'"
        [attr.aria-hidden]="activeSection() !== 'profile'"
      >
        <h2>{{ 'profile' | translate }}</h2>
        <app-account-profile
          [modal]="true"
          (profileSaveSuccess)="onProfileSaveSuccess()"
          (profileSaveError)="onProfileSaveError()"
        ></app-account-profile>
      </section>
      <section
        class="section"
        [class.section-hidden]="activeSection() !== 'account'"
        [attr.aria-hidden]="activeSection() !== 'account'"
      >
        <h2>{{ 'sidebar_menu_account' | translate }}</h2>
        <div class="mb-4 hidden-xs required-labels-field">
          {{ 'required_fields_label' | translate }}
        </div>
        <app-account-settings
          [modal]="true"
          [displayHeader]="false"
          (passwordChangeSuccess)="onPasswordChangeSuccess()"
          (passwordChangeError)="onPasswordChangeError()"
        ></app-account-settings>
      </section>
    </div>
  </div>
  <ng-template ds-modal-slide-out-footer>
    <ds-button-group
      [primaryAction]="{
        label: 'account_settings_modal_save_button_label' | translate,
      }"
      [secondAction]="{ label: 'form_cancel' | translate, variant: DsButtonVariants.secondary }"
      (primaryActionClicked)="onSave()"
      (secondActionClicked)="onCancel()"
    >
    </ds-button-group>
  </ng-template>
</ds-modal>
